const labelToKey = (label) => {
    return label
        .replace(/[^a-zA-Z0-9 ]/g, '')
        .split(' ')
        .map((word, index) => index === 0
            ? word.toLowerCase()
            : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join('');
};

const getFieldKey = (field) => field.value || labelToKey(field.label);

const checkNotOptional = (field, form) => {
    let requiredFormField = form.find(item => item.value === field);
    return requiredFormField?.isOptional === false;
}

const getActiveConditionalRule = (field, allValues) => {
    if (!field.conditionalValidation || !field.dependsOn) return null;
    const depKey = getFieldKey({ label: field.dependsOn });
    const depValue = allValues[depKey];
    if (!depValue) return null;
    return field.conditionalValidation.find(rule => {
        if (rule.when === depValue || rule.whenValue === depValue) return true;
        if (rule.whenIn && Array.isArray(rule.whenIn) && rule.whenIn.includes(depValue)) return true;
        return false;
    }) || null;
};

export {checkNotOptional, labelToKey, getFieldKey, getActiveConditionalRule}